// extracted by mini-css-extract-plugin
module.exports = {"root":"Dashboard_root__1RJZ-","col":"Dashboard_col__22qwa","col_big":"Dashboard_col_big__3PfMd","requestCountCard":"Dashboard_requestCountCard__1IoxW"};